module.exports = "https://cdn.hellotech.com/client-assets/repeating-calendar_240b95b3dad382bd933ddea67a287647.svg";